module.exports = __webpack_public_path__ + "assets/teach-myself.713d8a73.svg";